<template>
	<div class="col-lg-12">
		<dynvibebasechart
			:id="axiosComputed"
			ref="basechart"
			@created="chartCreated"
			:functionClick="clickGraph"
			:type="type"
		></dynvibebasechart>
		<input class="range-slider" type="range" v-model="currentIndex" :min="min" :max="max" />
	</div>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";
export default {
	name: "dynvibeBarChartRace",
	mixins: [graphMixin],
	props: {
		legend: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			baseChart: undefined,
			allSeries: [],
			currentSeries: [],
			currentIndex: 0,
			allLabels: [],
			min: 0,
			max: 0,
			maxCount: 0,
		};
	},
	mounted() {
		setTimeout(() => {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();
		}, 1250);
	},
	methods: {
		setChartOptions() {
			if (!this.baseChart) {
				this.baseChart = this.$refs.basechart;
			}
			if (!this.$refs.basechart) {
				return;
			}

			let chartOptions = this.baseChart.getChartOptions();
			chartOptions.chart = {
				type: "bubble",
				marginTop: 20,
			};
			chartOptions.xAxis.labels = {
				enabled: false,
			};

			chartOptions.plotOptions.bubble = {
				minSize: 3,
				maxSize: 100,
				zMin: 0,
				zMax: 100,
			};

			chartOptions.tooltip = {
				useHTML: true,
				headerFormat: "<table>",
				pointFormat: '<tr><th colspan="2"><h4>{point.name}</h4></th></tr>' + "<tr><th>Posts:</th><td>{point.y}</td></tr>",
				footerFormat: "</table>",
				followPointer: true,
			};
			this.baseChart.updateChartOptions(chartOptions);
		},

		loadChartData(results) {
			if (!this.baseChart) {
				this.baseChart = this.$refs.basechart;
			}

			this.allSeries = results.values.data;

			let noData = this.allSeries.length === 0;
			this.baseChart.setNoData(noData);
			this.allLabels = results.labels;
			this.currentIndex = 0;
			this.min = 0;
			this.max = this.allSeries.length - 1;

			let lastSeries = this.allSeries[this.max];
			for (let i = 0; i < lastSeries.length; i++) {
				if (lastSeries[i][1] > this.maxCount) {
					this.maxCount = lastSeries[i][1];
				}
			}

			this.words = [];
			for (let i = 0; i < this.allSeries.length; i++) {
				let series = this.allSeries[i];
				for (let j = 0; j < series.length; j++) {
					if (this.words.indexOf(series[j][0]) === -1) {
						this.words.push(series[j][0]);
					}
				}
			}

			this.words.sort();

			let formattedSeries = [];
			for (let i = 0; i < this.allSeries.length; i++) {
				let series = this.allSeries[i];
				let formatted = [];
				for (let j = 0; j < this.words.length; j++) {
					let found = false;
					for (let k = 0; k < series.length; k++) {
						if (this.words[j] === series[k][0]) {
							let item = {
								x: j,
								y: series[k][1],
								z: (series[k][1] / this.maxCount) * 100,
								name: this.words[j],
								visible: true,
							};
							formatted.push(item);
							found = true;
							break;
						}
					}
					if (!found) {
						formatted.push({ x: j, y: 0, z: 0, name: this.words[j], visible: false });
					}
				}
				formattedSeries.push(formatted);
			}

			this.allSeries = formattedSeries;

			this.updateData();

			this.$emit("graphloaded");

			let intervalId = setInterval(() => {
				this.currentIndex += 1;
				if (this.currentIndex === this.allSeries.length - 1) {
					window.clearInterval(intervalId);
				}
			}, 1000);
		},
		updateData() {
			let chartOptions = this.baseChart.getChartOptions();
			this.currentSeries = this.allSeries[this.currentIndex];
			chartOptions.yAxis.max = this.maxCount * 1.5;

			chartOptions.series = [{ data: this.currentSeries, animation: false, sizeBy: "width" }];
			this.baseChart.updateChartOptions(chartOptions);
		},
	},
	watch: {
		noData: function () {
			if (this.noData == true) this.$emit("graphloaded");
			console.log("noData watch");
		},
		currentIndex: function () {
			this.updateData();
		},
	},
};
</script>
<style scoped></style>
